import React from 'react';
import { Link } from 'react-router-dom';

export const WHATSAPP_URL = 'https://wa.me/5217712438160';

// Encabezado de página: etiqueta, título con degradado y subtítulo (mismo estilo que Planes/Promociones)
export const Encabezado = ({ etiqueta, titulo, subtitulo, children }) => (
    <div className="planesItmex-header">
        {etiqueta && <span className="planesItmex-eyebrow">{etiqueta}</span>}
        <h1 className="tituloItmex">{titulo}</h1>
        {subtitulo && <p className="planesItmex-subtitulo">{subtitulo}</p>}
        {children}
    </div>
);

// Panel lila a todo el ancho con botón principal + WhatsApp (mismo que Cobertura/Beneficios)
export const PanelContacto = ({ etiqueta, titulo, texto, ctaTexto = 'Contáctanos', ctaTo = '/contacto', whatsappMensaje }) => (
    <aside className="planesItmex-panel coberturaPanel">
        {etiqueta && <span className="planesItmex-eyebrow">{etiqueta}</span>}
        <h3 className="planesItmex-panel-titulo">{titulo}</h3>
        <p>{texto}</p>
        <div className="planesItmex-panel-acciones">
            <Link className="heroItmex-cta planesItmex-panel-cta" to={ctaTo}>
                {ctaTexto}
                <span className="heroItmex-cta-arrow"><i className="fas fa-arrow-right"></i></span>
            </Link>
            <a className="planesItmex-panel-whatsapp" href={WHATSAPP_URL + (whatsappMensaje ? '?text=' + encodeURIComponent(whatsappMensaje) : '')} target="_blank" rel="noopener noreferrer">
                <i className="fab fa-whatsapp"></i> WhatsApp
            </a>
        </div>
    </aside>
);
